import { useLinkedContext } from '@context/LinkedItemZoneContext'
import { useScrollOnLoad } from '@hooks/useScrollOnLoad'
import { useAppStore } from '@store'
import getStandardMaterial, { BackAcabadosInfo } from '@utils/conversion/getStandardMaterial'
import isLinked from '@utils/sceneObjects/assertions/isLinked'
import clsx from 'clsx'
import { EditorButtons } from '../EditorButtons'
import { LinkedItem, LinkedItemsID, Textures, AnyID, Store, LinkedItemSon } from '../../../types'
import { useState } from 'react'
import { calculateTiradorPosition } from '../../../utils/calculateTiradorPosition'
import { useEffect } from 'react'
import cleanExistingSuffixes from '@context/utils/linked/cleanExistingSuffixes'
import getSuffixForAcabado from '@context/utils/linked/getSuffixForAcabado'
import { adjustChildrenPositionsAfterInheritance } from '@utils/sceneObjects/items/adjustChildrenToEncimera'

type Props = {
  closeFn: () => void
  isObjectSelected?: number
}

export type LinkedOption = {
  idElementosEnlazados: number
  idUnidadEnlazada: number
  descripcion: string
  descripcionLarga: string
  referenciaJpgpng: string
  ordenVisual: number
  porDefecto: boolean
}

export type LinkedOptionWithNodo = LinkedOption & { nodo: number }

export default function LinkedTexturesEditor({ closeFn, isObjectSelected }: Props) {
  const {
    rightInfo,
    isModel,
    linkedOptions,
    highlighted,
    selectedTexture,
    setSelectedTexture,
    acabado,
    modelo,
    IamUp,
    // setPasteIcons,
    modeEditor,
    setModeEditor,
  } = useLinkedContext()

  // Función para normalizar descripcionLarga: convertir a minúsculas y capitalizar primera letra
  const normalizeDescripcionLarga = (text: string): string => {
    if (!text) return text
    const lowerCase = text.toLowerCase()
    return lowerCase.charAt(0).toUpperCase() + lowerCase.slice(1)
  }

  const [immediateSelectedTexture, setImmediateSelectedTexture] = useState<BackAcabadosInfo | null>(
    null,
  )

  useEffect(() => {
    const checkForZocaloUpdates = () => {
      try {
        const currentItems = useAppStore.getState().items
        const linkedItems = Array.from(currentItems.values()).filter(
          (item) => item.type === 'linkedItem',
        ) as any[]

        const updatedZocaloItems = linkedItems.filter(
          (item) => item.zocaloUpdated && item.lastZocaloUpdate,
        )

        if (updatedZocaloItems.length > 0) {
          if (rightInfo.name === 'Basico' || rightInfo.name === 'Zocalo') {
            updatedZocaloItems.forEach((item) => {
              useAppStore.setState((s) => {
                const currentItem = s.items.get(item.id as AnyID)
                if (currentItem && isLinked(currentItem)) {
                  ;(currentItem as any).zocaloUpdated = false
                }
              })
            })

            setImmediateSelectedTexture(null)
            setTimeout(() => setImmediateSelectedTexture(immediateSelectedTexture), 10)
          } else {
            updatedZocaloItems.forEach((item) => {
              item.zocaloUpdated = false
            })
          }
        }
      } catch (e) {
        console.warn('[LinkedTexturesEditor] Error en sincronización zócalo:', e)
      }
    }

    const interval = setInterval(checkForZocaloUpdates, 200)

    return () => clearInterval(interval)
  }, [rightInfo.name, immediateSelectedTexture])

    const postHighlighted = (
    typeof highlighted === 'string' ? highlighted.split('!').at(0) : ''
  ) as LinkedItemsID
  const childrenObject = useAppStore((s) => s.items.get(postHighlighted ?? '')) as
    | LinkedItemSon
    | undefined
  const editTexture = useAppStore.use.editLinkedTexture2()
  const editLinkedElementTexture = useAppStore.use.editLinkedElementTexture()
  const applyToAllItems = useAppStore((s) => s.applyTheSelectedoZoneToAllLinkedZonesWithSameName)
  const applyToAllItemsSelected = useAppStore((s) => s.applyTheSelectedZoneToSpecificLinkedZones)
  // const { setCopiedIconId } = useLinkedContext()
  const [parentNode, node] = [childrenObject?.parentOption, childrenObject?.option]
  const { scrollableEditorRef } = useScrollOnLoad([rightInfo, acabado])
  const { scrollableEditorRef: linkedOptionsScrollRef } = useScrollOnLoad([rightInfo, acabado])
  const isObjectSelectedSet = useAppStore((store) => store.layers[store.currentLayer].selected)
  const selected = useAppStore((store) => store.layers[store.currentLayer]?.selected ?? new Set())

  const items = useAppStore((s) => s.items)

  const mbjItems = new Set(
    Array.from(items.values())
      .filter((item) => item.tipoNormalizado === 'MBJ')
      .map((item) => item.id),
  )

  const malItems = new Set(
    Array.from(items.values())
      .filter((item) => item.tipoNormalizado === 'MAL')
      .map((item) => item.id),
  )

  const colItems = new Set(
    Array.from(items.values())
      .filter((item) => item.tipoNormalizado === 'COL')
      .map((item) => item.id),
  )

  const getFirstLinkedItemByType = (items: Map<string, LinkedItem>, tipoNormalizado: string) => {
    for (const [, item] of items) {
      if (item.type === 'linkedItem' && item.tipoNormalizado === tipoNormalizado) {
        return item
      }
    }
    return null
  }

  // function normalize(str?: string) {
  //   return (str ?? '')
  //     .toLowerCase()
  //     .normalize('NFD')
  //     .replace(/[\u0000-\u036f]/g, '')
  //     .trim()
  // }
  function isSelectedTexture(texture: BackAcabadosInfo) {
    if (immediateSelectedTexture && immediateSelectedTexture.idTexturas === texture.idTexturas) {
      return true
    }

    if (rightInfo.name === 'Encimera') {
      if (selectedTexture && 'searchID' in selectedTexture) {
        if (texture.idTexturas && String(selectedTexture.searchID) === String(texture.idTexturas)) {
          return true
        }

        if (!selectedTexture.searchID || selectedTexture.searchID === 0) {
          if (selectedTexture.name && texture.nombre && selectedTexture.name === texture.nombre) {
            return true
          }
        }

        return false
      }
      return false

      // const sonTexture = childrenObject?.textures?.[0]
      // if (sonTexture && 'searchID' in sonTexture && texture.idTexturas) {
      //   return String(sonTexture.searchID) === String(texture.idTexturas)
      // }

      // const acabadoNorm = normalize(acabado)
      // const nombreNorm = normalize(texture.nombre)
      // const descripcionNorm = normalize(texture.descripcion)
      // return acabadoNorm === nombreNorm || acabadoNorm === descripcionNorm
    }

    if (selectedTexture && 'searchID' in selectedTexture) {
      // Primero comparar por searchID
      if (selectedTexture.searchID === texture.idTexturas) {
        // Si el searchID coincide, también verificar que el name coincida para asegurar que es la textura correcta
        // Esto es importante cuando hay múltiples texturas con el mismo searchID pero diferentes nombres
        if (selectedTexture.name && texture.nombre) {
          return (
            selectedTexture.name === texture.nombre || selectedTexture.name === texture.descripcion
          )
        }
        // Si no hay name en selectedTexture, solo comparar por searchID
        return true
      }
      // Si el searchID NO coincide, comparar por name (importante después de cambio de gola)
      // porque el searchID puede cambiar pero el name debería ser el mismo
      if (selectedTexture.name && texture.nombre) {
        return (
          selectedTexture.name === texture.nombre || selectedTexture.name === texture.descripcion
        )
      }
      if (selectedTexture.description && texture.descripcion) {
        return selectedTexture.description === texture.descripcion
      }
      return false
    }
    return false
  }

  function handleClickSingle(texture: BackAcabadosInfo) {
    if (!isLinked(childrenObject) || !postHighlighted) return

    const linkedItem = useAppStore.getState().items.get(postHighlighted)
    if (!linkedItem || linkedItem.type !== 'linkedItem') return

    const highlightedZoneName = highlighted?.split('!')?.[1] || ''

    const highlightedTexture = linkedItem.textures?.find(
      (t: any) => t.zoneName === highlightedZoneName,
    )
    const selectedZoneDisplayName =
      highlightedTexture?.zoneDisplayName || rightInfo?.name || selectedTexture?.zoneDisplayName

    const selectedZoneName = highlightedZoneName || selectedTexture?.zoneName || ''

    const isChangingFromParent = !postHighlighted.startsWith('linkedSon_')

    if (!selectedZoneName) {
      const newTexture = editTexture(
        postHighlighted,
        selectedTexture?.zoneName ?? '',
        {
          ...getStandardMaterial(texture),
          acabado,
          modelo,
        },
        'Single',
      )
      if (newTexture) {
        setSelectedTexture(newTexture)
        // setCopiedIconId('')
        // setPasteIcons((prev: Record<string, string>) =>
        //   Object.fromEntries(Object.entries(prev).map(([key]) => [key, 'cantPaste'])),
        // )
      }
      return
    }

    const zonesToUpdate: string[] = []

    if (linkedItem.textures) {
      linkedItem.textures.forEach((tex) => {
        // Comparar por zoneName exacto (fuente de verdad) o por zoneDisplayName
        if (tex.zoneName === selectedZoneName || tex.zoneDisplayName === selectedZoneDisplayName) {
          zonesToUpdate.push(tex.zoneName)
        }
      })
    }

    // NO buscar zonas en los hijos cuando se cambia desde el padre
    // Esto evita que cambiar un acabado del padre modifique incorrectamente los hijos
    // Solo buscar en hijos si estamos cambiando desde un hijo específico
    if (!isChangingFromParent && linkedItem.childs) {
      Array.from(linkedItem.childs).forEach((childId) => {
        const child = useAppStore.getState().items.get(childId)
        if (child && child.type === 'linkedSon' && child.textures) {
          child.textures.forEach((tex) => {
            if (
              tex.zoneName === selectedZoneName ||
              tex.zoneDisplayName === selectedZoneDisplayName
            ) {
              zonesToUpdate.push(tex.zoneName)
            }
          })
        }
      })
    }

    let appliedTexture: Textures[number] | null = null
    zonesToUpdate.forEach((zoneName) => {
      // Solo aplicar al padre cuando se cambia desde LinkedObjectZonesEditor
      const targetId = isChangingFromParent ? postHighlighted : postHighlighted
      const newTexture = editTexture(
        targetId,
        zoneName,
        {
          ...getStandardMaterial(texture),
          acabado,
          modelo,
        },
        'Single',
      )
      if (newTexture && !appliedTexture) {
        appliedTexture = newTexture
      }
    })

    if (appliedTexture) {
      setSelectedTexture(appliedTexture)
      // setCopiedIconId('')
      // setPasteIcons((prev: Record<string, string>) =>
      //   Object.fromEntries(Object.entries(prev).map(([key]) => [key, 'cantPaste'])),
      // )
    }
  }

  function handleClickAll(texture: BackAcabadosInfo) {
    if (!isLinked(childrenObject) || !postHighlighted) return

    const highlightedZoneName = highlighted?.split('!')?.[1] || ''

    // const linkedItem = items.get(postHighlighted)
    // const linkedItemTextures = Array.isArray(linkedItem?.textures) ? linkedItem.textures : []
    // const highlightedTexture = linkedItemTextures.find(
    //   (t: any) => t.zoneName === highlightedZoneName,
    // )
    // const selectedZoneDisplayName =
    //   highlightedTexture?.zoneDisplayName || rightInfo?.name || selectedTexture?.zoneDisplayName

    const selectedZoneName = highlightedZoneName || selectedTexture?.zoneName || ''

    const newTexture = editTexture(
      postHighlighted,
      selectedZoneName,
      {
        ...getStandardMaterial(texture),
        acabado,
        modelo,
      },
      'All',
    )
    if (newTexture) {
      setSelectedTexture(newTexture)
      const zoneName = (newTexture as Textures[number]).zoneName
      if (typeof zoneName === 'string') {
        applyToAllItems(postHighlighted, zoneName)
      }
    }
  }

  const isVitrinaLinkedItem = (candidate: any): candidate is LinkedItem => {
    if (!isLinked(candidate)) return false

    const puertaTexture = candidate.textures?.find((t: any) => t.zoneDisplayName === 'Puerta')
    const modelo = puertaTexture?.modelo?.toLowerCase() ?? ''
    const catalogID = String(candidate.catalogID ?? '').toUpperCase()

    return (
      modelo.includes('vitrina') ||
      catalogID.startsWith('KABV') ||
      catalogID.startsWith('KAPV') ||
      catalogID.startsWith('PE KABV') ||
      catalogID.startsWith('PE KAPV')
    )
  }

  const isVitrinaModel = (): boolean => {
    if (!postHighlighted) return false

    const linkedItem = items.get(postHighlighted)
    if (!linkedItem) return false

    return isVitrinaLinkedItem(linkedItem)
  }

  const vitrinaItems = new Set<LinkedItemsID>(
    Array.from(items.values())
      .filter((item): item is LinkedItem => isVitrinaLinkedItem(item))
      .map((item) => item.id as LinkedItemsID),
  )

  function handleClickSelected(texture: BackAcabadosInfo) {
    if (!isLinked(childrenObject) || !postHighlighted) return

    let selectedSet: Set<LinkedItemsID>

    if (isVitrinaModel()) {
      // Cuando es vitrina, modo "Selected" debe comportarse como "All" para todas las vitrinas
      selectedSet = vitrinaItems.size > 0 ? vitrinaItems : new Set([postHighlighted])
    } else {
      selectedSet =
        isObjectSelectedSet && isObjectSelectedSet.size > 0
          ? isObjectSelectedSet
          : new Set([postHighlighted])
    }

    const newTexture = editTexture(
      postHighlighted,
      selectedTexture?.zoneName ?? '',
      {
        ...getStandardMaterial(texture),
        acabado,
        modelo,
      },
      'Selected',
      selectedSet,
    )

    if (newTexture) {
      setSelectedTexture(newTexture)
      const zoneName = (newTexture as Textures[number]).zoneName
      if (typeof zoneName === 'string' && selectedSet.size > 0) {
        applyToAllItemsSelected(postHighlighted, zoneName, selectedSet)
      }
    }
  }

  function handleClickMBJ(texture: BackAcabadosInfo) {
    if (!isLinked(childrenObject) || !postHighlighted) return
    const firstMbjItem = getFirstLinkedItemByType(items as Map<string, LinkedItem>, 'MBJ')
    if (!firstMbjItem) return
    const matchingTexture = firstMbjItem.textures.find(
      (t) => t.zoneDisplayName === selectedTexture?.zoneDisplayName,
    )
    const zoneToUse = matchingTexture?.zoneName || firstMbjItem.textures[0].zoneName

    const newTexture = editTexture(
      firstMbjItem.id,
      zoneToUse,
      {
        ...getStandardMaterial(texture),
        acabado,
        modelo,
      },
      'MBJ',
      mbjItems as Set<LinkedItemsID>,
    )
    if (newTexture) {
      setSelectedTexture(newTexture)
      const zoneName = (newTexture as Textures[number]).zoneName
      if (typeof zoneName === 'string') {
        applyToAllItemsSelected(firstMbjItem.id, zoneName, mbjItems as Set<LinkedItemsID>)
      }
    }
  }

  function handleClickMAL(texture: BackAcabadosInfo) {
    if (!isLinked(childrenObject) || !postHighlighted) return

    const firstMalItem = getFirstLinkedItemByType(items as Map<string, LinkedItem>, 'MAL')
    if (!firstMalItem) return
    const matchingTexture = firstMalItem.textures.find(
      (t) => t.zoneDisplayName === selectedTexture?.zoneDisplayName,
    )
    const zoneToUse = matchingTexture?.zoneName || firstMalItem.textures[0].zoneName

    const newTexture = editTexture(
      firstMalItem.id,
      zoneToUse,
      {
        ...getStandardMaterial(texture),
        acabado,
        modelo,
      },
      'MAL',
      malItems as Set<LinkedItemsID>,
    )
    if (newTexture) {
      setSelectedTexture(newTexture)
      const zoneName = (newTexture as Textures[number]).zoneName
      if (typeof zoneName === 'string') {
        applyToAllItemsSelected(firstMalItem.id, zoneName, malItems as Set<LinkedItemsID>)
      }
    }
  }

  function handleClickCOL(texture: BackAcabadosInfo) {
    if (!isLinked(childrenObject) || !postHighlighted) return
    const firstColItem = getFirstLinkedItemByType(items as Map<string, LinkedItem>, 'COL')
    if (!firstColItem) return
    const matchingTexture = firstColItem.textures.find(
      (t) =>
        selectedTexture &&
        typeof t === 'object' &&
        'zone' in t &&
        'zone' in selectedTexture &&
        t.zone === selectedTexture.zone,
    )
    const zoneToUse = matchingTexture?.zoneName || firstColItem.textures[0].zoneName
    const newTexture = editTexture(
      firstColItem.id,
      zoneToUse,
      {
        ...getStandardMaterial(texture),
        acabado,
        modelo,
      },
      'COL',
      colItems as Set<LinkedItemsID>,
    )
    if (newTexture) {
      setSelectedTexture(newTexture)
      const zoneName = (newTexture as Textures[number]).zoneName
      if (typeof zoneName === 'string') {
        applyToAllItemsSelected(firstColItem.id, zoneName, colItems as Set<LinkedItemsID>)
      }
    }
  }

  function handleClick(texture: BackAcabadosInfo) {
    setImmediateSelectedTexture(texture)
    handleClickAsync(texture)
  }

  const handleClickAsync = async (texture: BackAcabadosInfo) => {
    applyTexture(texture)
    setImmediateSelectedTexture(null)

    const currentCatalogId = (childrenObject?.catalogID as string) || ''
    const isGola = currentCatalogId.includes(' GO')
    let newCatalogId: string | null = null

    if (isGola) {
      const suffixRaw = getSuffixForAcabado(acabado || '') // p.ej. ' LA', ' LI', ' Ru', ' R2'
      const suffix = suffixRaw.trim() // 'LA' | 'LI' | 'Ru' | 'R2'

      const removeSuffixBeforeGO = (code: string) => code.replace(/\s+(LA|LI|Ru|R2)\s+GO$/i, ' GO')
      const currentNoSpecial = removeSuffixBeforeGO(currentCatalogId)
      const base = currentNoSpecial.replace(/\s+GO$/i, '')

      if (suffix === '') {
        newCatalogId = `${base} GO`
      } else {
        newCatalogId = `${base} ${suffix} GO`
      }

      // NO ejecutar applyGLBChange si el catalogID no cambió realmente
      if (newCatalogId === currentCatalogId) {
        return
      }
    } else {
      newCatalogId = determineNewCatalogId(acabado)
    }

    if (newCatalogId && newCatalogId !== currentCatalogId) {
      setTimeout(() => {
        applyGLBChange(newCatalogId!).catch((e) => console.error('applyGLBChange error:', e))
      }, 0)
    }
  }

  const determineNewCatalogId = (textureAcabado: string): string | null => {
    if (!childrenObject?.catalogID) {
      return null
    }

    if (childrenObject.type !== 'linkedItem') {
      return null
    }

    const currentCatalogId = childrenObject.catalogID as string

    const isGola = currentCatalogId.includes(' GO')

    if (isGola) {
      return null
    }

    const baseCatalogId = cleanExistingSuffixes(currentCatalogId)

    const suffix = getSuffixForAcabado(textureAcabado)

    const newCatalogId = baseCatalogId + suffix

    if (newCatalogId === currentCatalogId) {
      return null
    }

    return newCatalogId
  }

  const applyGLBChange = async (newCatalogId: string) => {
    if (!childrenObject?.id) {
      return
    }

    try {
      const store = useAppStore.getState()
      const updateLinkedItemGLB = store.updateLinkedItemGLB
      const updateLinkedGLBForGroup = store.updateLinkedGLBForGroup

      store.setFrameloop('always')

      if (modeEditor === 'All') {
        const linkedItemIds = Array.from(store.items.keys()).filter((id) => {
          const item = store.items.get(id)
          return (
            id.startsWith('linkedItem_') &&
            item &&
            item.type === 'linkedItem' &&
            (item as any).description !== 'Frontal'
          )
        })

        const batchPromises: Promise<any>[] = []
        for (const itemId of linkedItemIds) {
          const linkedItem = store.items.get(itemId)
          if (linkedItem && linkedItem.type === 'linkedItem') {
            const currentCatalogId = linkedItem.catalogID as string
            let elementSpecificNewCatalogId: string

            const isGola = newCatalogId.includes(' GO')

            if (isGola) {
              const suffixRaw = getSuffixForAcabado(acabado)
              const suffix = suffixRaw.trim()

              const removeSuffixBeforeGO = (code: string) =>
                code.replace(/\s+(LA|LI|Ru|R2)\s+GO$/i, ' GO')
              const currentNoSpecial = removeSuffixBeforeGO(currentCatalogId)
              const base = currentNoSpecial.replace(/\s+GO$/i, '')

              if (suffix === '') {
                elementSpecificNewCatalogId = `${base} GO`
              } else {
                elementSpecificNewCatalogId = `${base} ${suffix} GO`
              }
            } else {
              const baseCatalogId = cleanExistingSuffixes(currentCatalogId)
              const suffix = getSuffixForAcabado(acabado)
              elementSpecificNewCatalogId = baseCatalogId + suffix
            }

            const currentTirador = Array.from(linkedItem.childs ?? [])
              .map((childID) => store.items.get(childID))
              .find((child) => child && child.description === 'Tirador')

            const currentGrifo = Array.from(linkedItem.childs ?? [])
              .map((childID) => store.items.get(childID))
              .find(
                (child) =>
                  child &&
                  ((child as any).typeOfSon === 'Grifo' ||
                    (child.description && child.description.toLowerCase().includes('grifo'))),
              )

            const currentFregadero = Array.from(linkedItem.childs ?? [])
              .map((childID) => store.items.get(childID))
              .find(
                (child) =>
                  child &&
                  ((child as any).typeOfSon === 'Fregadero' ||
                    (child.description && child.description.toLowerCase().includes('fregadero'))),
              )

            const allChildrenInfo: any = {
              tirador: {
                idElementosEnlazados: (currentTirador as any)?.idElementosEnlazados,
                descripcion: (currentTirador as any)?.descripcion,
                catalogID: (currentTirador as any)?.catalogID,
                isSinTirador:
                  (currentTirador as any)?.descripcion?.toLowerCase().includes('sin tirador') ||
                  false,
              },
              grifo: {
                catalogID: (currentGrifo as any)?.catalogID,
              },
              fregadero: {
                catalogID: (currentFregadero as any)?.catalogID,
              },
            }

            if (!store.originalTiradors) {
              useAppStore.setState((s) => {
                s.originalTiradors = new Map()
              })
            }

            useAppStore.setState((s) => {
              if (!s.originalTiradors) {
                s.originalTiradors = new Map()
              }
              s.originalTiradors.set(itemId, allChildrenInfo)
            })

            const p = (async () => {
              const success = await updateLinkedItemGLB(itemId, elementSpecificNewCatalogId)
              if (!success) return

              let retries = 0
              while (retries < 50) {
                const currentItem = useAppStore.getState().items.get(itemId) as any
                if (currentItem?.grifoOptions && currentItem?.fregaderoOptions) {
                  break
                }
                await new Promise((resolve) => setTimeout(resolve, 50))
                retries++
              }

              const storeAfterUpdate = useAppStore.getState()
              const linkedItemAfterUpdate = storeAfterUpdate.items.get(itemId) as any

              const savedChildrenInfo = storeAfterUpdate.originalTiradors?.get(itemId) as any

              const catalogChanged = currentCatalogId !== elementSpecificNewCatalogId

              if (catalogChanged && savedChildrenInfo && linkedItemAfterUpdate) {
                // Actualizar cada grifo individualmente usando su linkedID específico
                if (linkedItemAfterUpdate.grifoOptions && linkedItemAfterUpdate.childs) {
                  const grifos = Array.from(linkedItemAfterUpdate.childs)
                    .map((childID) => storeAfterUpdate.items.get(childID))
                    .filter(
                      (child) =>
                        child &&
                        ((child as any).typeOfSon === 'Grifo' ||
                          (child.description && child.description.toLowerCase().includes('grifo'))),
                    )

                  for (const grifo of grifos) {
                    if (!grifo) continue
                    const grifoLinkedID = (grifo as any).linkedID
                    const grifoCatalogID = (grifo as any).catalogID
                    const grifoDescription = (grifo as any).description
                    const grifoNodo = (grifo as any).nodo
                    const grifoParentOption = (grifo as any).parentOption

                    if (!grifoLinkedID) {
                      continue
                    }

                    let matchingOption = linkedItemAfterUpdate.grifoOptions.find(
                      (opt: any) => opt.idElementosEnlazados === grifoLinkedID,
                    )

                    if (!matchingOption) {
                      let nodoToUse = grifoNodo

                      // Si no está definido, intentar usar option (que suele corresponder al nodo)
                      if (nodoToUse === undefined || nodoToUse === null) {
                        const grifoOption = (grifo as any).option
                        if (grifoOption !== undefined && grifoOption !== null) {
                          nodoToUse = grifoOption
                        }
                      }

                      // Si aún no está definido, buscar el nodo en las opciones del padre anterior usando el linkedID actual
                      if (nodoToUse === undefined || nodoToUse === null) {
                        const currentItem = useAppStore
                          .getState()
                          .items.get(itemId as LinkedItemsID)
                        if (
                          currentItem &&
                          currentItem.type === 'linkedItem' &&
                          (currentItem as LinkedItem).grifoOptions
                        ) {
                          const currentGrifoOption = (
                            (currentItem as LinkedItem).grifoOptions as any[]
                          ).find((opt: any) => opt.idElementosEnlazados === grifoLinkedID)
                          if (
                            currentGrifoOption &&
                            currentGrifoOption.nodo !== undefined &&
                            currentGrifoOption.nodo !== null
                          ) {
                            nodoToUse = currentGrifoOption.nodo
                            console.log('🟡 [APPLY GLB CHANGE] Nodo obtenido de opción anterior:', {
                              grifoID: grifo.id,
                              nodo: nodoToUse,
                              linkedID: grifoLinkedID,
                            })
                          }
                        }
                      }

                      // Si aún no está definido, buscar el nodo en las nuevas opciones usando el linkedID actual
                      if (
                        (nodoToUse === undefined || nodoToUse === null) &&
                        linkedItemAfterUpdate.grifoOptions
                      ) {
                        const currentGrifoOptionInNew = linkedItemAfterUpdate.grifoOptions.find(
                          (opt: any) => opt.idElementosEnlazados === grifoLinkedID,
                        )
                        if (
                          currentGrifoOptionInNew &&
                          currentGrifoOptionInNew.nodo !== undefined &&
                          currentGrifoOptionInNew.nodo !== null
                        ) {
                          nodoToUse = currentGrifoOptionInNew.nodo
                          console.log('🟡 [APPLY GLB CHANGE] Nodo obtenido de nuevas opciones:', {
                            grifoID: grifo.id,
                            nodo: nodoToUse,
                            linkedID: grifoLinkedID,
                          })
                        }
                      }

                      if (nodoToUse !== undefined) {
                        // Buscar por catalogID + nodo (esto asegura que encontramos la opción correcta para esta posición específica)
                        matchingOption = linkedItemAfterUpdate.grifoOptions.find(
                          (opt: any) =>
                            ((opt.codigo || opt.catalogID) === grifoCatalogID ||
                              opt.descripcion === grifoCatalogID) &&
                            opt.nodo === nodoToUse,
                        )
                      }

                      if (!matchingOption) {
                        console.warn(
                          '⚠️ [APPLY GLB CHANGE] No se encontró por catalogID + nodo, buscando solo por catalogID:',
                          {
                            grifoID: grifo.id,
                            catalogID: grifoCatalogID,
                            nodo: nodoToUse,
                          },
                        )
                        matchingOption = linkedItemAfterUpdate.grifoOptions.find(
                          (opt: any) =>
                            (opt.codigo || opt.catalogID) === grifoCatalogID ||
                            opt.descripcion === grifoDescription ||
                            opt.descripcion === grifoCatalogID,
                        )
                      }
                    }

                    // Si aún no se encuentra, buscar por descripción
                    if (!matchingOption && grifoDescription) {
                      matchingOption = linkedItemAfterUpdate.grifoOptions.find(
                        (opt: any) =>
                          opt.descripcion?.toLowerCase().includes(grifoDescription.toLowerCase()) ||
                          grifoDescription
                            .toLowerCase()
                            .includes(opt.descripcion?.toLowerCase() || ''),
                      )
                    }

                    // Si aún no se encuentra, usar la primera opción disponible como fallback
                    if (!matchingOption && linkedItemAfterUpdate.grifoOptions.length > 0) {
                      matchingOption = linkedItemAfterUpdate.grifoOptions[0]
                    }

                    if (matchingOption) {
                      await updateLinkedGLBForGroup(
                        new Set([itemId]),
                        matchingOption.idElementosEnlazados,
                        linkedItemAfterUpdate.grifoOptions,
                        'Grifo',
                        grifoLinkedID, // Pasar el linkedID anterior para que mantenga la posición
                      )
                    }
                  }
                } else if (
                  savedChildrenInfo.grifo?.catalogID &&
                  linkedItemAfterUpdate.grifoOptions
                ) {
                  const targetGrifoOption = linkedItemAfterUpdate.grifoOptions.find(
                    (opt) => (opt as any).descripcion === savedChildrenInfo.grifo.catalogID,
                  )

                  if (targetGrifoOption) {
                    await updateLinkedGLBForGroup(
                      new Set([itemId]),
                      (targetGrifoOption as any).idElementosEnlazados,
                      linkedItemAfterUpdate.grifoOptions,
                      'Grifo',
                    )
                  }
                }

                if (
                  savedChildrenInfo.fregadero?.catalogID &&
                  linkedItemAfterUpdate.fregaderoOptions
                ) {
                  const targetFregaderoOption = linkedItemAfterUpdate.fregaderoOptions.find(
                    (opt) => (opt as any).descripcion === savedChildrenInfo.fregadero.catalogID,
                  )

                  if (targetFregaderoOption) {
                    await updateLinkedGLBForGroup(
                      new Set([itemId]),
                      (targetFregaderoOption as any).idElementosEnlazados,
                      linkedItemAfterUpdate.fregaderoOptions,
                      'Fregadero',
                    )
                  }
                }
              }
            })()
            batchPromises.push(p)
          }
        }
        await Promise.allSettled(batchPromises)
        try {
          const r3f = typeof window !== 'undefined' ? (window as any).r3f : undefined
          r3f?.invalidate?.()
          requestAnimationFrame(() => r3f?.invalidate?.())
        } catch {}
      } else {
        // Obtener el item padre del highlighted para excluirlo si no es del tipo correcto
        const currentParentItem = Array.from(store.items.values()).find((item) => {
          if (item.type === 'linkedItem' && item.childs) {
            const hasChild = Array.from(item.childs).includes(childrenObject.id as AnyID)
            return hasChild
          }
          return false
        }) as LinkedItem | undefined

        let itemsToChange: LinkedItem[] = []

        if (modeEditor === 'MBJ') {
          itemsToChange = Array.from(store.items.values()).filter(
            (item): item is LinkedItem =>
              item.type === 'linkedItem' &&
              (item as LinkedItem).tipoNormalizado === 'MBJ' &&
              !(
                currentParentItem &&
                currentParentItem.id === item.id &&
                currentParentItem.tipoNormalizado !== 'MBJ'
              ),
          ) as LinkedItem[]
        } else if (modeEditor === 'MAL') {
          itemsToChange = Array.from(store.items.values()).filter(
            (item): item is LinkedItem =>
              item.type === 'linkedItem' &&
              (item as LinkedItem).tipoNormalizado === 'MAL' &&
              !(
                currentParentItem &&
                currentParentItem.id === item.id &&
                currentParentItem.tipoNormalizado !== 'MAL'
              ),
          ) as LinkedItem[]
        } else if (modeEditor === 'COL') {
          itemsToChange = Array.from(store.items.values()).filter(
            (item): item is LinkedItem =>
              item.type === 'linkedItem' &&
              (item as LinkedItem).tipoNormalizado === 'COL' &&
              !(
                currentParentItem &&
                currentParentItem.id === item.id &&
                currentParentItem.tipoNormalizado !== 'COL'
              ),
          ) as LinkedItem[]
        } else if (modeEditor === 'Selected') {
          const selectedSet = isObjectSelectedSet as Set<LinkedItemsID>
          itemsToChange = Array.from(selectedSet)
            .map((id) => store.items.get(id))
            .filter((item): item is LinkedItem => item?.type === 'linkedItem') as LinkedItem[]
        } else {
          const linkedItem = store.items.get(childrenObject.id)
          if (linkedItem && linkedItem.type === 'linkedItem') {
            itemsToChange = [linkedItem]
          }
        }

        const batchPromises: Promise<any>[] = []
        for (const linkedItem of itemsToChange) {
          const currentTirador = Array.from(linkedItem.childs ?? [])
            .map((childID) => store.items.get(childID))
            .find((child) => child && child.description === 'Tirador')

          const currentTiradorInfo = {
            idElementosEnlazados: (currentTirador as any)?.idElementosEnlazados,
            descripcion: (currentTirador as any)?.descripcion,
            catalogID: (currentTirador as any)?.catalogID,
            isSinTirador:
              (currentTirador as any)?.descripcion?.toLowerCase().includes('sin tirador') || false,
          }

          const wasSinTirador =
            currentTiradorInfo.isSinTirador || currentTiradorInfo.catalogID === 'Sin Tirador'

          if (
            !currentTiradorInfo.isSinTirador &&
            currentTiradorInfo.catalogID &&
            currentTiradorInfo.catalogID !== 'Sin Tirador'
          ) {
            if (!store.originalTiradors) {
              useAppStore.setState((s) => {
                s.originalTiradors = new Map()
              })
            }

            useAppStore.setState((s) => {
              if (!s.originalTiradors) {
                s.originalTiradors = new Map()
              }
              s.originalTiradors.set(linkedItem.id, currentTiradorInfo)
            })
          }

          // Calcular el nuevo catalogID específico para este item
          const currentCatalogId = linkedItem.catalogID as string
          let elementSpecificNewCatalogId: string

          const isGola = newCatalogId.includes(' GO')

          if (isGola) {
            const suffixRaw = getSuffixForAcabado(acabado)
            const suffix = suffixRaw.trim()

            const removeSuffixBeforeGO = (code: string) =>
              code.replace(/\s+(LA|LI|Ru|R2)\s+GO$/i, ' GO')
            const currentNoSpecial = removeSuffixBeforeGO(currentCatalogId)
            const base = currentNoSpecial.replace(/\s+GO$/i, '')

            if (suffix === '') {
              elementSpecificNewCatalogId = `${base} GO`
            } else {
              elementSpecificNewCatalogId = `${base} ${suffix} GO`
            }
          } else {
            const baseCatalogId = cleanExistingSuffixes(currentCatalogId)
            const suffix = getSuffixForAcabado(acabado)
            elementSpecificNewCatalogId = baseCatalogId + suffix
          }

          const p = (async () => {
            const success = await updateLinkedItemGLB(linkedItem.id, elementSpecificNewCatalogId)
            if (!success) return

            let retries = 0
            while (retries < 50) {
              const currentItem = useAppStore.getState().items.get(linkedItem.id) as any
              if (currentItem?.tiradorOptions) {
                break
              }
              await new Promise((resolve) => setTimeout(resolve, 50))
              retries++
            }

            const storeAfterUpdate = useAppStore.getState()
            const linkedItemAfterUpdate = storeAfterUpdate.items.get(linkedItem.id) as any

            if (linkedItemAfterUpdate) {
              if (elementSpecificNewCatalogId.includes(' LI')) {
                if (linkedItemAfterUpdate.tiradorOptions) {
                  const sinTiradorOption = linkedItemAfterUpdate.tiradorOptions.find((opt: any) =>
                    opt.descripcion?.toLowerCase().includes('sin tirador'),
                  )

                  if (sinTiradorOption) {
                    updateLinkedGLBForGroup(
                      new Set([linkedItem.id]),
                      sinTiradorOption.idElementosEnlazados,
                      linkedItemAfterUpdate.tiradorOptions,
                      'Tirador',
                    )
                  }
                }
              } else {
                if (wasSinTirador && linkedItemAfterUpdate.tiradorOptions) {
                  const originalTiradorInfo = storeAfterUpdate.originalTiradors?.get(linkedItem.id)

                  if (originalTiradorInfo && originalTiradorInfo.catalogID) {
                    const targetTiradorOption = linkedItemAfterUpdate.tiradorOptions.find(
                      (opt: any) => opt.descripcion === originalTiradorInfo.catalogID,
                    )

                    if (targetTiradorOption) {
                      updateLinkedGLBForGroup(
                        new Set([linkedItem.id]),
                        targetTiradorOption.idElementosEnlazados,
                        linkedItemAfterUpdate.tiradorOptions,
                        'Tirador',
                      )
                    }
                  } else {
                    let targetTiradorOption = null

                    if (localSelectedId) {
                      targetTiradorOption = linkedItemAfterUpdate.tiradorOptions.find(
                        (opt: any) => opt.idElementosEnlazados === localSelectedId,
                      )
                    }

                    if (!targetTiradorOption) {
                      targetTiradorOption = linkedItemAfterUpdate.tiradorOptions.find(
                        (opt: any) => opt.porDefecto === true,
                      )
                    }

                    if (targetTiradorOption) {
                      updateLinkedGLBForGroup(
                        new Set([linkedItem.id]),
                        targetTiradorOption.idElementosEnlazados,
                        linkedItemAfterUpdate.tiradorOptions,
                        'Tirador',
                      )
                    }
                  }
                }
              }
            }
          })()
          batchPromises.push(p)
        }

        await Promise.allSettled(batchPromises)
        try {
          const r3f = typeof window !== 'undefined' ? (window as any).r3f : undefined
          r3f?.invalidate?.()
          requestAnimationFrame(() => r3f?.invalidate?.())
        } catch {}
      }
    } catch (error) {
      console.error('❌ Error aplicando cambio de GLB:', error)
    }
  }

  const applyTexture = (texture: BackAcabadosInfo) => {
    if (rightInfo.name === 'Encimera') {
      if (
        modeEditor === 'Single' ||
        modeEditor === 'All' ||
        modeEditor === 'Selected' ||
        modeEditor === 'MBJ' ||
        modeEditor === 'MAL' ||
        modeEditor === 'COL'
      ) {
        let selectedIdsForMode: Set<LinkedItemsID> | undefined
        if (modeEditor === 'Selected') {
          selectedIdsForMode = isObjectSelectedSet as Set<LinkedItemsID>
        } else if (modeEditor === 'MBJ') {
          selectedIdsForMode = mbjItems as Set<LinkedItemsID>
        } else if (modeEditor === 'MAL') {
          selectedIdsForMode = malItems as Set<LinkedItemsID>
        } else if (modeEditor === 'COL') {
          selectedIdsForMode = colItems as Set<LinkedItemsID>
        }

        if (!childrenObject?.id) {
          return
        }

        const newTexture = editLinkedElementTexture(
          childrenObject.id,
          {
            ...getStandardMaterial(texture),
            acabado: acabado,
            modelo: (texture as BackAcabadosInfo & { modelo?: string }).modelo ?? 'encimera',
          },
          modeEditor,
          selectedIdsForMode,
        )

        if (newTexture) {
          setSelectedTexture(newTexture)
          // setCopiedIconId('')
          // setPasteIcons((prev: Record<string, string>) =>
          //   Object.fromEntries(Object.entries(prev).map(([key]) => [key, 'cantPaste'])),
          // )

          const updateEncimeraHeight = () => {
            const store = useAppStore.getState()
            let newHeight = 20

            if (acabado === 'Porcelanicas 12') {
              newHeight = 12
            } else if (acabado === 'Porcelanicas 20') {
              newHeight = 20
            } else if (acabado === 'Postformadas') {
              newHeight = 30
            } else if (acabado === 'Compacto') {
              newHeight = 10
            }

            const updateEncimeraHeight = useAppStore.getState().updateEncimeraHeight
            if (updateEncimeraHeight) {
              if (modeEditor === 'All') {
                const allItems = Array.from(store.items.values())
                const encimeras = allItems.filter(
                  (item) => item.description === 'Encimera' && item.type === 'linkedSon',
                )

                encimeras.forEach((encimera) => {
                  updateEncimeraHeight(encimera.id, newHeight)
                    .then(() => {
                      const parentItem = store.items.get((encimera as any).firstParentID)
                      if (
                        parentItem &&
                        parentItem.type === 'linkedItem' &&
                        parentItem.childs &&
                        Array.isArray(parentItem.childs) &&
                        parentItem.childs.length > 0
                      ) {
                        adjustChildrenPositionsAfterInheritance(
                          parentItem,
                          (childId: any) => store.items.get(childId),
                          (childId: any, updates: any) => {
                            store.editItem(childId, updates)
                          },
                        )
                      }
                    })
                    .catch((error) => {
                      console.error(`Error updating encimera height for ${encimera.id}:`, error)
                    })
                })
              } else {
                const childItem = store.items.get(childrenObject.id)
                if (childItem && childItem.description === 'Encimera') {
                  updateEncimeraHeight(childrenObject.id, newHeight)
                    .then(() => {
                      const parentItem = store.items.get((childItem as any).firstParentID)
                      if (
                        parentItem &&
                        parentItem.type === 'linkedItem' &&
                        parentItem.childs &&
                        Array.isArray(parentItem.childs) &&
                        parentItem.childs.length > 0
                      ) {
                        adjustChildrenPositionsAfterInheritance(
                          parentItem,
                          (childId: any) => store.items.get(childId),
                          (childId: any, updates: any) => {
                            store.editItem(childId, updates)
                          },
                        )
                      }
                    })
                    .catch((error) => {
                      console.error('Error updating encimera height:', error)
                    })
                }
              }
            }
          }

          updateEncimeraHeight()
        }
        return
      }
    }

    if (isVitrinaModel()) {
      if (modeEditor === 'Single') {
        handleClickSingle(texture)
      } else {
        handleClickSelected(texture)
      }
    } else {
      if (modeEditor === 'Single') {
        handleClickSingle(texture)
      } else if (modeEditor === 'All') {
        handleClickAll(texture)
      } else if (modeEditor === 'Selected') {
        handleClickSelected(texture)
      } else if (modeEditor === 'MBJ') {
        handleClickMBJ(texture)
      } else if (modeEditor === 'MAL') {
        handleClickMAL(texture)
      } else if (modeEditor === 'COL') {
        handleClickCOL(texture)
      }
    }
  }

  const action = useAppStore.use.updateLinkedGLB()
  const updateLinkedGLBForGroup = useAppStore.use.updateLinkedGLBForGroup()
  const applyToAllItemsGLB = useAppStore((s) => s.applyToAllItemsAndChildrens)
  const setLinkedTiradorPosition = useAppStore.use.setLinkedTiradorPosition()

  function handleLinkedClick(el: LinkedOption) {
    if (!childrenObject) {
      return
    }

    const typeOfSon = childrenObject.description

    if (typeOfSon === 'Tirador') {
      if (!linkedOptions) return
      if (modeEditor === 'Single') {
        action(highlighted, el.idElementosEnlazados, linkedOptions)
      } else if (modeEditor === 'All') {
        const itemsArr = Array.from(items.values()).filter(
          (i) => i.type === 'linkedItem',
        ) as LinkedItem[]
        itemsArr.forEach((item) => {
          let tiradorOption = item.tiradorOptions?.find(
            (opt) => String(opt.idUnidadEnlazada) === String(el.idUnidadEnlazada),
          )
          if (!tiradorOption) {
            tiradorOption = item.tiradorOptions?.find((opt) =>
              opt.descripcion?.toLowerCase().includes('sin tirador'),
            )
          }
          if (!tiradorOption) return
          const idElementosEnlazadosNuevo = (tiradorOption as any).idElementosEnlazados

          const tiradorHijo = Array.from(item.childs ?? [])
            .map((childID) => items.get(childID))
            .find((child) => child && child.description === 'Tirador')
          const idElementosEnlazadosAnt = (tiradorHijo as any)?.idElementosEnlazados
          if (idElementosEnlazadosAnt === undefined) {
            return
          }
          updateLinkedGLBForGroup(
            new Set([item.id]),
            idElementosEnlazadosNuevo,
            item.tiradorOptions ?? [],
            'Tirador',
            idElementosEnlazadosAnt,
          )
        })
      } else if (modeEditor === 'MBJ') {
        Array.from(mbjItems).forEach((mbjId) => {
          const mbjItem = items.get(mbjId as AnyID) as any
          if (!mbjItem) return
          let tiradorOption = mbjItem.tiradorOptions?.find(
            (opt: any) => String(opt.idUnidadEnlazada) === String(el.idUnidadEnlazada),
          )
          if (!tiradorOption) {
            tiradorOption = mbjItem.tiradorOptions?.find((opt: any) =>
              opt.descripcion?.toLowerCase().includes('sin tirador'),
            )
          }
          if (!tiradorOption) return
          const idElementosEnlazadosNuevo = tiradorOption.idElementosEnlazados
          const tiradorHijo = Array.from(mbjItem.childs ?? [])
            .map((childID) => items.get(childID as AnyID))
            .find((child) => child && child.description === 'Tirador')
          const idElementosEnlazadosAnt = (tiradorHijo as any)?.idElementosEnlazados
          if (idElementosEnlazadosAnt === undefined) return
          updateLinkedGLBForGroup(
            new Set([mbjItem.id]),
            idElementosEnlazadosNuevo,
            mbjItem.tiradorOptions ?? [],
            'Tirador',
            idElementosEnlazadosAnt,
          )
        })

        Array.from(mbjItems).forEach((mbjId) => {
          const mbjItem = items.get(mbjId as AnyID) as any
          if (!mbjItem || !mbjItem.childs) return
          Array.from(mbjItem.childs as Set<string>).forEach((childId) => {
            const child = items.get(childId as AnyID) as any
            if (child && child.description === 'Tirador') {
              const nuevaPos = calculateTiradorPosition(child, mbjItem)
              setLinkedTiradorPosition(child.id, nuevaPos.x, nuevaPos.y, nuevaPos.z)
            }
          })
        })
      } else if (modeEditor === 'MAL') {
        Array.from(malItems).forEach((malId) => {
          const malItem = items.get(malId as AnyID) as any
          if (!malItem) return
          let tiradorOption = malItem.tiradorOptions?.find(
            (opt: any) => String(opt.idUnidadEnlazada) === String(el.idUnidadEnlazada),
          )
          if (!tiradorOption) {
            tiradorOption = malItem.tiradorOptions?.find((opt: any) =>
              opt.descripcion?.toLowerCase().includes('sin tirador'),
            )
          }
          if (!tiradorOption) return
          const idElementosEnlazadosNuevo = tiradorOption.idElementosEnlazados
          const tiradorHijo = Array.from(malItem.childs ?? [])
            .map((childID) => items.get(childID as AnyID))
            .find((child) => child && child.description === 'Tirador')
          const idElementosEnlazadosAnt = (tiradorHijo as any)?.idElementosEnlazados
          if (idElementosEnlazadosAnt === undefined) return
          updateLinkedGLBForGroup(
            new Set([malItem.id]),
            idElementosEnlazadosNuevo,
            malItem.tiradorOptions ?? [],
            'Tirador',
            idElementosEnlazadosAnt,
          )
        })
        Array.from(malItems).forEach((malId) => {
          const malItems = items.get(malId as AnyID) as any
          if (!malItems || !malItems.childs) return
          Array.from(malItems.childs as Set<string>).forEach((childId) => {
            const child = items.get(childId as AnyID) as any
            if (child && child.description === 'Tirador') {
              const nuevaPos = calculateTiradorPosition(child, malItems)
              setLinkedTiradorPosition(child.id, nuevaPos.x, nuevaPos.y, nuevaPos.z)
            }
          })
        })
      } else if (modeEditor === 'COL') {
        Array.from(colItems).forEach((colId) => {
          const colItem = items.get(colId as AnyID) as any
          if (!colItem) return
          let tiradorOption = colItem.tiradorOptions?.find(
            (opt: any) => String(opt.idUnidadEnlazada) === String(el.idUnidadEnlazada),
          )
          if (!tiradorOption) {
            tiradorOption = colItem.tiradorOptions?.find((opt: any) =>
              opt.descripcion?.toLowerCase().includes('sin tirador'),
            )
          }
          if (!tiradorOption) return
          const idElementosEnlazadosNuevo = tiradorOption.idElementosEnlazados
          const tiradorHijo = Array.from(colItem.childs ?? [])
            .map((childID) => items.get(childID as AnyID))
            .find((child) => child && child.description === 'Tirador')
          const idElementosEnlazadosAnt = (tiradorHijo as any)?.idElementosEnlazados
          if (idElementosEnlazadosAnt === undefined) return
          updateLinkedGLBForGroup(
            new Set([colItem.id]),
            idElementosEnlazadosNuevo,
            colItem.tiradorOptions ?? [],
            'Tirador',
            idElementosEnlazadosAnt,
          )
        })
        Array.from(colItems).forEach((colId) => {
          const colItems = items.get(colId as AnyID) as any
          if (!colItems || !colItems.childs) return
          Array.from(colItems.childs as Set<string>).forEach((childId) => {
            const child = items.get(childId as AnyID) as any
            if (child && child.description === 'Tirador') {
              const nuevaPos = calculateTiradorPosition(child, colItems)
              setLinkedTiradorPosition(child.id, nuevaPos.x, nuevaPos.y, nuevaPos.z)
            }
          })
        })
      } else if (modeEditor === 'Selected') {
        updateLinkedGLBForGroup(selected, el.idElementosEnlazados, linkedOptions, 'Tirador')
      }
    } else if (typeOfSon === 'Fregadero') {
      if (modeEditor === 'Single') {
        action(highlighted, el.idElementosEnlazados, linkedOptions)
      } else if (modeEditor === 'All') {
        updateLinkedGLBForGroup(
          new Set([highlighted]),
          el.idElementosEnlazados,
          linkedOptions,
          'Fregadero',
          undefined,
          'All',
        )
      } else if (modeEditor === 'Selected') {
        updateLinkedGLBForGroup(
          selected,
          el.idElementosEnlazados,
          linkedOptions,
          'Fregadero',
          undefined,
          'Selected',
        )
      }
    } else if (typeOfSon === 'TPCGrifo') {
      if (modeEditor === 'Single') {
        action(highlighted, el.idElementosEnlazados, linkedOptions)
      } else if (modeEditor === 'All') {
        updateLinkedGLBForGroup(
          new Set([highlighted]),
          el.idElementosEnlazados,
          linkedOptions,
          'TPCGrifo',
          undefined,
          'All',
        )
      } else if (modeEditor === 'Selected') {
        updateLinkedGLBForGroup(
          selected,
          el.idElementosEnlazados,
          linkedOptions,
          'TPCGrifo',
          undefined,
          'Selected',
        )
      }
    } else if (typeOfSon && typeOfSon.toLowerCase().includes('encimera')) {
      // console.log(
      //   '🔵 ENCIMERA - modeEditor:',
      //   modeEditor,
      //   'typeOfSon:',
      //   typeOfSon,
      //   'highlighted:',
      //   highlighted,
      // )
      const currentParentItem = Array.from(items.values()).find((item) => {
        if (item.type === 'linkedItem' && item.childs) {
          const hasChild = Array.from(item.childs).includes(postHighlighted as AnyID)
          return hasChild
        }
        return false
      }) as LinkedItem | undefined
      // console.log(
      //   '🔵 ENCIMERA - currentParentItem:',
      //   currentParentItem?.id,
      //   'tipoNormalizado:',
      //   currentParentItem?.tipoNormalizado,
      // )

      if (modeEditor === 'Single') {
        // console.log('🔵 ENCIMERA - Single: aplicando GLB a highlighted')
        applyToAllItemsGLB(highlighted)
      } else if (modeEditor === 'All') {
        // console.log('🔵 ENCIMERA - All: aplicando GLB a highlighted')
        applyToAllItemsGLB(highlighted)
      } else if (modeEditor === 'MBJ') {
        const mbjIds = Array.from(mbjItems)
        // console.log(
        //   '🔵 ENCIMERA - MBJ: mbjItems:',
        //   mbjIds,
        //   'currentParentItem.id:',
        //   currentParentItem?.id,
        // )
        // Excluir el item seleccionado si no es MBJ
        const mbjToChange = mbjIds.filter((id) => {
          if (
            currentParentItem &&
            currentParentItem.id === id &&
            currentParentItem.tipoNormalizado !== 'MBJ'
          ) {
            // console.log('🔵 ENCIMERA - MBJ: EXCLUYENDO item seleccionado (no es MBJ):', id)
            return false
          }
          return true
        })
        if (mbjToChange.length > 0) {
          // console.log('🔵 ENCIMERA - MBJ: aplicando GLB a:', mbjToChange[0])
          applyToAllItemsGLB(mbjToChange[0])
        }
      } else if (modeEditor === 'MAL') {
        const malIds = Array.from(malItems)
        // console.log(
        //   '🔵 ENCIMERA - MAL: malItems:',
        //   malIds,
        //   'currentParentItem.id:',
        //   currentParentItem?.id,
        // )
        // Excluir el item seleccionado si no es MAL
        const malToChange = malIds.filter((id) => {
          if (
            currentParentItem &&
            currentParentItem.id === id &&
            currentParentItem.tipoNormalizado !== 'MAL'
          ) {
            // console.log('🔵 ENCIMERA - MAL: EXCLUYENDO item seleccionado (no es MAL):', id)
            return false
          }
          return true
        })
        if (malToChange.length > 0) {
          // console.log('🔵 ENCIMERA - MAL: aplicando GLB a:', malToChange[0])
          applyToAllItemsGLB(malToChange[0])
        }
      } else if (modeEditor === 'COL') {
        const colIds = Array.from(colItems)
        // console.log(
        //   '🔵 ENCIMERA - COL: colItems:',
        //   colIds,
        //   'currentParentItem.id:',
        //   currentParentItem?.id,
        // )
        // Excluir el item seleccionado si no es COL
        const colToChange = colIds.filter((id) => {
          if (
            currentParentItem &&
            currentParentItem.id === id &&
            currentParentItem.tipoNormalizado !== 'COL'
          ) {
            console.log('🔵 ENCIMERA - COL: EXCLUYENDO item seleccionado (no es COL):', id)
            return false
          }
          return true
        })
        if (colToChange.length > 0) {
          // console.log('🔵 ENCIMERA - COL: aplicando GLB a:', colToChange[0])
          applyToAllItemsGLB(colToChange[0])
        }
      } else if (modeEditor === 'Selected') {
        // console.log('🔵 ENCIMERA - Selected: aplicando GLB a selected items')
        selected.forEach((id) => applyToAllItemsGLB(id))
      }
    } else {
      if (!linkedOptions || parentNode === undefined || node === undefined) {
        return
      }
      const optionsForSon = linkedOptions[parentNode]?.[node]
      if (modeEditor === 'Single') {
        if (typeOfSon === 'Grifo' || typeOfSon === 'Placa' || typeOfSon === 'Fregadero') {
          const parentItem = Array.from(items.values()).find((item) => {
            if (item.type === 'linkedItem' && item.childs) {
              const hasChild = Array.from(item.childs).includes(highlighted as AnyID)

              return hasChild
            }
            return false
          }) as LinkedItem | undefined

          if (parentItem) {
            let specificOptions: ItemWithOptions[] = []
            if (typeOfSon === 'Grifo' && parentItem.grifoOptions) {
              specificOptions = parentItem.grifoOptions
            } else if (typeOfSon === 'Placa' && parentItem.placaOptions) {
              specificOptions = parentItem.placaOptions
            } else if (typeOfSon === 'Fregadero' && parentItem.fregaderoOptions) {
              specificOptions = parentItem.fregaderoOptions
            }

            const specificOption = specificOptions.find((opt) => opt.descripcion === el.descripcion)
            if (specificOption) {
              action(highlighted, specificOption.idElementosEnlazados, optionsForSon)
            } else {
              action(highlighted, el.idElementosEnlazados, optionsForSon)
            }
          } else {
            action(highlighted, el.idElementosEnlazados, optionsForSon)
          }
        } else {
          action(highlighted, el.idElementosEnlazados, optionsForSon)
        }
      } else if (modeEditor === 'All') {
        const itemsArr = Array.from(items.values()).filter(
          (i) => i.type === 'linkedItem',
        ) as LinkedItem[]

        // Para tipos genéricos (Micro, Horno, HornoMicro, etc.), usar updateLinkedGLBForGroup
        if (
          typeOfSon !== 'Grifo' &&
          typeOfSon !== 'Placa' &&
          typeOfSon !== 'Fregadero' &&
          !typeOfSon?.toLowerCase().includes('grifo')
        ) {
          const parentIDsWithChildren = new Set<string>()
          itemsArr.forEach((item) => {
            const child = Array.from(item.childs ?? [])
              .map((childID) => items.get(childID))
              .find((child) => child && child.description === typeOfSon)
            if (child) {
              parentIDsWithChildren.add(item.id)
            }
          })

          if (parentIDsWithChildren.size > 0) {
            const infoToPass = optionsForSon || linkedOptions || {}

            let correctIdElementosEnlazados = el.idElementosEnlazados
            if (infoToPass && typeof infoToPass === 'object') {
              for (const parentKey in infoToPass) {
                if (infoToPass[parentKey] && typeof infoToPass[parentKey] === 'object') {
                  const childOptions = infoToPass[parentKey][typeOfSon]
                  if (Array.isArray(childOptions)) {
                    const foundOption = childOptions.find(
                      (opt: any) => opt.descripcion === el.descripcion,
                    )
                    if (foundOption) {
                      correctIdElementosEnlazados = foundOption.idElementosEnlazados
                      break
                    }
                  }
                }
              }
            }

            let idElementosEnlazadosAnt: number | undefined = undefined
            for (const parentID of parentIDsWithChildren) {
              const parentItem = items.get(parentID as AnyID)
              if (parentItem && parentItem.type === 'linkedItem') {
                const child = Array.from(parentItem.childs ?? [])
                  .map((childID) => items.get(childID))
                  .find((child) => child && child.description === typeOfSon)
                if (child && (child as any).linkedID) {
                  idElementosEnlazadosAnt = (child as any).linkedID
                  break
                }
              }
            }

            updateLinkedGLBForGroup(
              parentIDsWithChildren,
              correctIdElementosEnlazados,
              infoToPass,
              typeOfSon,
              idElementosEnlazadosAnt,
              'All',
            )
            return
          }
        }

        const processedUnits = new Set<string>()

        itemsArr.forEach((item) => {
          if (processedUnits.has(item.id)) return

          if (item.snappedWall && item.snappedWall !== '') {
            const snappedGroup = itemsArr.filter(
              (linkedItem) => linkedItem.snappedWall === item.snappedWall,
            )

            snappedGroup.forEach((groupItem) => {
              const child = Array.from(groupItem.childs ?? [])
                .map((childID) => items.get(childID))
                .find((child) => child && child.description === typeOfSon)
              if (!child) return

              processedUnits.add(groupItem.id)

              let shouldApply = true
              let specificIdElementosEnlazados = el.idElementosEnlazados

              if (typeOfSon === 'Grifo' && groupItem.grifoOptions) {
                const specificOption = groupItem.grifoOptions.find(
                  (opt) => opt.descripcion === el.descripcion,
                )
                if (specificOption) {
                  specificIdElementosEnlazados = specificOption.idElementosEnlazados
                } else {
                  shouldApply = false
                }
              } else if (typeOfSon === 'Placa' && groupItem.placaOptions) {
                const specificOption = groupItem.placaOptions.find(
                  (opt) => opt.descripcion === el.descripcion,
                )
                if (specificOption) {
                  specificIdElementosEnlazados = specificOption.idElementosEnlazados
                } else {
                  shouldApply = false
                }
              } else if (typeOfSon === 'Fregadero' && groupItem.fregaderoOptions) {
                const specificOption = groupItem.fregaderoOptions.find(
                  (opt) => opt.descripcion === el.descripcion,
                )
                if (specificOption) {
                  specificIdElementosEnlazados = specificOption.idElementosEnlazados
                } else {
                  shouldApply = false
                }
              }

              if (shouldApply) {
                action(child.id, specificIdElementosEnlazados, optionsForSon)
              }
            })
          } else {
            const child = Array.from(item.childs ?? [])
              .map((childID) => items.get(childID))
              .find((child) => child && child.description === typeOfSon)
            if (!child) return

            let shouldApply = true
            let specificIdElementosEnlazados = el.idElementosEnlazados

            if (typeOfSon === 'Grifo' && item.grifoOptions) {
              const specificOption = item.grifoOptions.find(
                (opt) => opt.descripcion === el.descripcion,
              )
              if (specificOption) {
                specificIdElementosEnlazados = specificOption.idElementosEnlazados
              } else {
                shouldApply = false
              }
            } else if (typeOfSon === 'Placa' && item.placaOptions) {
              const specificOption = item.placaOptions.find(
                (opt) => opt.descripcion === el.descripcion,
              )
              if (specificOption) {
                specificIdElementosEnlazados = specificOption.idElementosEnlazados
              } else {
                shouldApply = false
              }
            } else if (typeOfSon === 'Fregadero' && item.fregaderoOptions) {
              const specificOption = item.fregaderoOptions.find(
                (opt) => opt.descripcion === el.descripcion,
              )
              if (specificOption) {
                specificIdElementosEnlazados = specificOption.idElementosEnlazados
              } else {
                shouldApply = false
              }
            }

            if (shouldApply) {
              action(child.id, specificIdElementosEnlazados, optionsForSon)
            }
          }
        })
      } else if (modeEditor === 'Selected') {
        if (
          typeOfSon !== 'Grifo' &&
          typeOfSon !== 'Placa' &&
          typeOfSon !== 'Fregadero' &&
          !typeOfSon?.toLowerCase().includes('grifo')
        ) {
          const parentIDsWithChildren = new Set<string>()
          selected.forEach((id) => {
            const item = items.get(id as AnyID)
            if (!item || item.type !== 'linkedItem') return
            const child = Array.from(item.childs ?? [])
              .map((childID) => items.get(childID))
              .find((child) => child && child.description === typeOfSon)
            if (child) {
              parentIDsWithChildren.add(id)
            }
          })

          if (parentIDsWithChildren.size > 0) {
            const infoToPass = optionsForSon || linkedOptions || {}

            let correctIdElementosEnlazados = el.idElementosEnlazados
            if (infoToPass && typeof infoToPass === 'object') {
              for (const parentKey in infoToPass) {
                if (infoToPass[parentKey] && typeof infoToPass[parentKey] === 'object') {
                  const childOptions = infoToPass[parentKey][typeOfSon]
                  if (Array.isArray(childOptions)) {
                    const foundOption = childOptions.find(
                      (opt: any) => opt.descripcion === el.descripcion,
                    )
                    if (foundOption) {
                      correctIdElementosEnlazados = foundOption.idElementosEnlazados
                      break
                    }
                  }
                }
              }
            }

            let idElementosEnlazadosAnt: number | undefined = undefined
            for (const parentID of parentIDsWithChildren) {
              const parentItem = items.get(parentID as AnyID)
              if (parentItem && parentItem.type === 'linkedItem') {
                const child = Array.from(parentItem.childs ?? [])
                  .map((childID) => items.get(childID))
                  .find((child) => child && child.description === typeOfSon)
                if (child && (child as any).linkedID) {
                  idElementosEnlazadosAnt = (child as any).linkedID
                  break
                }
              }
            }

            updateLinkedGLBForGroup(
              parentIDsWithChildren,
              correctIdElementosEnlazados,
              infoToPass,
              typeOfSon,
              idElementosEnlazadosAnt,
              'Selected',
            )
            return
          }
        }

        selected.forEach((id) => {
          const item = items.get(id as AnyID)
          if (!item || item.type !== 'linkedItem') return
          const child = Array.from(item.childs ?? [])
            .map((childID) => items.get(childID))
            .find((child) => child && child.description === typeOfSon)
          if (!child) return

          let shouldApply = true
          let specificIdElementosEnlazados = el.idElementosEnlazados

          if (typeOfSon === 'Grifo' && item.grifoOptions) {
            const specificOption = item.grifoOptions.find(
              (opt) => opt.descripcion === el.descripcion,
            )
            if (specificOption) {
              specificIdElementosEnlazados = specificOption.idElementosEnlazados
            } else {
              shouldApply = false
            }
          } else if (typeOfSon === 'Placa' && item.placaOptions) {
            const specificOption = item.placaOptions.find(
              (opt) => opt.descripcion === el.descripcion,
            )
            if (specificOption) {
              specificIdElementosEnlazados = specificOption.idElementosEnlazados
            } else {
              shouldApply = false
            }
          } else if (typeOfSon === 'Fregadero' && item.fregaderoOptions) {
            const specificOption = item.fregaderoOptions.find(
              (opt) => opt.descripcion === el.descripcion,
            )
            if (specificOption) {
              specificIdElementosEnlazados = specificOption.idElementosEnlazados
            } else {
              shouldApply = false
            }
          }

          if (shouldApply) {
            action(child.id, specificIdElementosEnlazados, optionsForSon)
          }
        })
      } else if (modeEditor === 'MBJ') {
        // Para tipos genéricos, usar updateLinkedGLBForGroup
        if (
          typeOfSon !== 'Grifo' &&
          typeOfSon !== 'Placa' &&
          typeOfSon !== 'Fregadero' &&
          !typeOfSon?.toLowerCase().includes('grifo')
        ) {
          const parentIDsWithChildren = new Set<string>()
          Array.from(mbjItems).forEach((mbjId) => {
            const mbjItem = items.get(mbjId as AnyID) as any
            if (!mbjItem) return
            const child = Array.from(mbjItem.childs ?? [])
              .map((childID) => items.get(childID as AnyID))
              .find((child) => child && child.description === typeOfSon)
            if (child) {
              parentIDsWithChildren.add(mbjItem.id)
            }
          })

          if (parentIDsWithChildren.size > 0) {
            const infoToPass = optionsForSon || linkedOptions || {}
            let correctIdElementosEnlazados = el.idElementosEnlazados
            if (infoToPass && typeof infoToPass === 'object') {
              for (const parentKey in infoToPass) {
                if (infoToPass[parentKey] && typeof infoToPass[parentKey] === 'object') {
                  const childOptions = infoToPass[parentKey][typeOfSon]
                  if (Array.isArray(childOptions)) {
                    const foundOption = childOptions.find(
                      (opt: any) => opt.descripcion === el.descripcion,
                    )
                    if (foundOption) {
                      correctIdElementosEnlazados = foundOption.idElementosEnlazados
                      break
                    }
                  }
                }
              }
            }

            let idElementosEnlazadosAnt: number | undefined = undefined
            for (const parentID of parentIDsWithChildren) {
              const parentItem = items.get(parentID as AnyID)
              if (parentItem && parentItem.type === 'linkedItem') {
                const child = Array.from(parentItem.childs ?? [])
                  .map((childID) => items.get(childID))
                  .find((child) => child && child.description === typeOfSon)
                if (child && (child as any).linkedID) {
                  idElementosEnlazadosAnt = (child as any).linkedID
                  break
                }
              }
            }

            updateLinkedGLBForGroup(
              parentIDsWithChildren,
              correctIdElementosEnlazados,
              infoToPass,
              typeOfSon,
              idElementosEnlazadosAnt,
              'MBJ',
            )
            return
          }
        }

        Array.from(mbjItems).forEach((mbjId) => {
          const mbjItem = items.get(mbjId as AnyID) as any
          if (!mbjItem) return
          const child = Array.from(mbjItem.childs ?? [])
            .map((childID) => items.get(childID as AnyID))
            .find((child) => child && child.description === typeOfSon)
          if (!child) return
          action(child.id, el.idElementosEnlazados, optionsForSon)
        })
      } else if (modeEditor === 'MAL') {
        // console.log(
        //   '🟢 MAL - modeEditor:',
        //   modeEditor,
        //   'typeOfSon:',
        //   typeOfSon,
        //   'highlighted:',
        //   highlighted,
        // )
        // Obtener el item padre del highlighted para excluirlo si no es MAL
        const currentParentItem = Array.from(items.values()).find((item) => {
          if (item.type === 'linkedItem' && item.childs) {
            const hasChild = Array.from(item.childs).includes(postHighlighted as AnyID)
            return hasChild
          }
          return false
        }) as LinkedItem | undefined
        // console.log(
        //   '🟢 MAL - currentParentItem:',
        //   currentParentItem?.id,
        //   'tipoNormalizado:',
        //   currentParentItem?.tipoNormalizado,
        // )

        // Para tipos genéricos, usar updateLinkedGLBForGroup
        if (
          typeOfSon !== 'Grifo' &&
          typeOfSon !== 'Placa' &&
          typeOfSon !== 'Fregadero' &&
          !typeOfSon?.toLowerCase().includes('grifo')
        ) {
          const parentIDsWithChildren = new Set<string>()
          Array.from(malItems).forEach((malId) => {
            // Excluir el item seleccionado si no es MAL
            if (
              currentParentItem &&
              currentParentItem.id === malId &&
              currentParentItem.tipoNormalizado !== 'MAL'
            ) {
              // console.log('🟢 MAL - EXCLUYENDO item seleccionado (no es MAL):', malId)
              return
            }
            const malItem = items.get(malId as AnyID) as any
            if (!malItem) return
            const child = Array.from(malItem.childs ?? [])
              .map((childID) => items.get(childID as AnyID))
              .find((child) => child && child.description === typeOfSon)
            if (child) {
              parentIDsWithChildren.add(malItem.id)
              // console.log('🟢 MAL - Agregando MAL item para cambiar GLB:', malItem.id)
            }
          })

          // console.log('🟢 MAL - parentIDsWithChildren:', Array.from(parentIDsWithChildren))

          if (parentIDsWithChildren.size > 0) {
            const infoToPass = optionsForSon || linkedOptions || {}
            let correctIdElementosEnlazados = el.idElementosEnlazados
            if (infoToPass && typeof infoToPass === 'object') {
              for (const parentKey in infoToPass) {
                if (infoToPass[parentKey] && typeof infoToPass[parentKey] === 'object') {
                  const childOptions = infoToPass[parentKey][typeOfSon]
                  if (Array.isArray(childOptions)) {
                    const foundOption = childOptions.find(
                      (opt: any) => opt.descripcion === el.descripcion,
                    )
                    if (foundOption) {
                      correctIdElementosEnlazados = foundOption.idElementosEnlazados
                      break
                    }
                  }
                }
              }
            }

            let idElementosEnlazadosAnt: number | undefined = undefined
            for (const parentID of parentIDsWithChildren) {
              const parentItem = items.get(parentID as AnyID)
              if (parentItem && parentItem.type === 'linkedItem') {
                const child = Array.from(parentItem.childs ?? [])
                  .map((childID) => items.get(childID))
                  .find((child) => child && child.description === typeOfSon)
                if (child && (child as any).linkedID) {
                  idElementosEnlazadosAnt = (child as any).linkedID
                  break
                }
              }
            }

            // console.log('🟢 MAL - Llamando updateLinkedGLBForGroup con:', {
            //   parentIDs: Array.from(parentIDsWithChildren),
            //   idElementosEnlazados: correctIdElementosEnlazados,
            //   typeOfSon,
            //   modeEditor: 'MAL',
            // })
            updateLinkedGLBForGroup(
              parentIDsWithChildren,
              correctIdElementosEnlazados,
              infoToPass,
              typeOfSon,
              idElementosEnlazadosAnt,
              'MAL',
            )
            return
          }
        }

        Array.from(malItems).forEach((malId) => {
          // Excluir el item seleccionado si no es MAL
          if (
            currentParentItem &&
            currentParentItem.id === malId &&
            currentParentItem.tipoNormalizado !== 'MAL'
          ) {
            return
          }
          const malItem = items.get(malId as AnyID) as any
          if (!malItem) return
          const child = Array.from(malItem.childs ?? [])
            .map((childID) => items.get(childID as AnyID))
            .find((child) => child && child.description === typeOfSon)
          if (!child) return
          action(child.id, el.idElementosEnlazados, optionsForSon)
        })
      } else if (modeEditor === 'COL') {
        // Para tipos genéricos, usar updateLinkedGLBForGroup
        if (
          typeOfSon !== 'Grifo' &&
          typeOfSon !== 'Placa' &&
          typeOfSon !== 'Fregadero' &&
          !typeOfSon?.toLowerCase().includes('grifo')
        ) {
          const parentIDsWithChildren = new Set<string>()
          Array.from(colItems).forEach((colId) => {
            const colItem = items.get(colId as AnyID) as any
            if (!colItem) return
            const child = Array.from(colItem.childs ?? [])
              .map((childID) => items.get(childID as AnyID))
              .find((child) => child && child.description === typeOfSon)
            if (child) {
              parentIDsWithChildren.add(colItem.id)
            }
          })

          if (parentIDsWithChildren.size > 0) {
            const infoToPass = optionsForSon || linkedOptions || {}
            let correctIdElementosEnlazados = el.idElementosEnlazados
            if (infoToPass && typeof infoToPass === 'object') {
              for (const parentKey in infoToPass) {
                if (infoToPass[parentKey] && typeof infoToPass[parentKey] === 'object') {
                  const childOptions = infoToPass[parentKey][typeOfSon]
                  if (Array.isArray(childOptions)) {
                    const foundOption = childOptions.find(
                      (opt: any) => opt.descripcion === el.descripcion,
                    )
                    if (foundOption) {
                      correctIdElementosEnlazados = foundOption.idElementosEnlazados
                      break
                    }
                  }
                }
              }
            }

            let idElementosEnlazadosAnt: number | undefined = undefined
            for (const parentID of parentIDsWithChildren) {
              const parentItem = items.get(parentID as AnyID)
              if (parentItem && parentItem.type === 'linkedItem') {
                const child = Array.from(parentItem.childs ?? [])
                  .map((childID) => items.get(childID))
                  .find((child) => child && child.description === typeOfSon)
                if (child && (child as any).linkedID) {
                  idElementosEnlazadosAnt = (child as any).linkedID
                  break
                }
              }
            }

            updateLinkedGLBForGroup(
              parentIDsWithChildren,
              correctIdElementosEnlazados,
              infoToPass,
              typeOfSon,
              idElementosEnlazadosAnt,
              'COL',
            )
            return
          }
        }

        Array.from(colItems).forEach((colId) => {
          const colItem = items.get(colId as AnyID) as any
          if (!colItem) return
          const child = Array.from(colItem.childs ?? [])
            .map((childID) => items.get(childID as AnyID))
            .find((child) => child && child.description === typeOfSon)
          if (!child) return
          action(child.id, el.idElementosEnlazados, optionsForSon)
        })
      }
    }
  }

  const [localSelectedId, setLocalSelectedId] = useState<number | null>(null)

  const isContextGroup =
    (childrenObject &&
      (modeEditor === (childrenObject as any).tipoNormalizado ||
        modeEditor === 'Single' ||
        modeEditor === 'All')) ||
    false

  useEffect(() => {
    if (isContextGroup) {
      setLocalSelectedId(null)
    }
  }, [modeEditor, childrenObject?.id])

  useEffect(() => {
    if (isVitrinaModel() && modeEditor !== 'Single' && modeEditor !== 'Selected') {
      setModeEditor('Selected')
    }
  }, [isVitrinaModel(), modeEditor])

  const renderLinkedOptions = () => {
    if (!childrenObject) return null

    const findMatchingOption = (): LinkedOptionWithNodo[] => {
      if (!linkedOptions || parentNode === undefined || !linkedOptions[parentNode]) {
        return []
      }

      const parentOptions = linkedOptions[parentNode]
      const availableOptionNames = Object.keys(parentOptions)

      if (childrenObject.description && parentOptions[childrenObject.description]) {
        return parentOptions[childrenObject.description]
      }

      const childType = childrenObject.description?.replace(/[0-9]/g, '') // "TPCGrifo1" -> "TPCGrifo" :-S
      if (childType && parentOptions[childType]) {
        return parentOptions[childType]
      }

      for (const optionName of availableOptionNames) {
        if (optionName === childrenObject.description || optionName === childType) {
          return parentOptions[optionName]
        }
      }

      const partialMatch = availableOptionNames.find((optionName) => {
        const includes1 = childrenObject.description
          ?.toLowerCase()
          .includes(optionName.toLowerCase())
        const includes2 = optionName
          .toLowerCase()
          .includes(childrenObject.description?.toLowerCase() || '')
        const includes3 = childType?.toLowerCase().includes(optionName.toLowerCase())
        const includes4 = optionName.toLowerCase().includes(childType?.toLowerCase() || '')

        return includes1 || includes2 || includes3 || includes4
      })

      if (partialMatch) {
        return parentOptions[partialMatch]
      }

      const keywordMap: { [key: string]: string[] } = {
        grifo: ['TPCGrifo'],
        fregadero: ['Fregadero'],
        encimera: ['Encimera'],
        tirador: ['Tirador'],
      }

      const childDescriptionLower = childrenObject.description?.toLowerCase() || ''
      const matchingKeywords = Object.keys(keywordMap).filter((keyword) =>
        childDescriptionLower.includes(keyword),
      )

      for (const keyword of matchingKeywords) {
        const possibleTypes = keywordMap[keyword]
        for (const type of possibleTypes) {
          if (parentOptions[type]) {
            return parentOptions[type]
          }
        }
      }

      if (node !== undefined && node < availableOptionNames.length) {
        const optionNameByIndex = availableOptionNames[node]

        return parentOptions[optionNameByIndex]
      }

      if (availableOptionNames.length > 0) {
        const firstOption = availableOptionNames[0]

        return parentOptions[firstOption]
      }

      return []
    }

    const allElements: LinkedOptionWithNodo[] = findMatchingOption()

    const normalizedElements = allElements.map((el) => {
      const areEqual =
        el.descripcion &&
        el.descripcionLarga &&
        el.descripcion.trim() === el.descripcionLarga.trim()

      const normalizedDescripcionLarga = el.descripcionLarga
        ? normalizeDescripcionLarga(el.descripcionLarga)
        : el.descripcionLarga

      return {
        ...el,
        descripcionLarga: normalizedDescripcionLarga,
        _wereEqual: areEqual,
      }
    })

    if (normalizedElements.length === 0) {
      return (
        <div className='p-4 text-red-500'>
          No hay opciones disponibles para {childrenObject.description}
          <div className='mt-2 text-xs'>
            Opciones disponibles:{' '}
            {linkedOptions[parentNode]
              ? Object.keys(linkedOptions[parentNode]).join(', ')
              : 'ninguna'}
          </div>
        </div>
      )
    }

    return (
      <div
        ref={linkedOptionsScrollRef}
        className='scrollable-editor flex max-h-[520px] flex-wrap gap-x-5 gap-y-9 overflow-x-hidden overflow-y-scroll p-2'
      >
        {normalizedElements
          .filter(
            (el, index, array) =>
              array.findIndex((item) => item.descripcion === el.descripcion) === index,
          )
          .map((el, index) => {
            return (
              <div
                className='flex max-h-44 flex-col'
                key={`${el.idElementosEnlazados}-${index}`}
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  if (isContextGroup) {
                    handleLinkedClick(el as LinkedOption)
                  } else {
                    setLocalSelectedId(el.idElementosEnlazados)
                    handleLinkedClick(el as LinkedOption)
                  }
                }}
              >
                <img
                  className={`h-32 w-32 cursor-pointer object-contain ${
                    isContextGroup
                      ? el.descripcion === childrenObject?.catalogID
                        ? 'elElegido outline outline-4 outline-red-500'
                        : ''
                      : localSelectedId === el.idElementosEnlazados
                        ? 'elElegido outline outline-4 outline-red-500'
                        : ''
                  }`}
                  src={
                    el.referenciaJpgpng ??
                    'https://h23api.for2home.com/CatalogData/ItemImages/Texturas/Cocinas_1_9_1/Cocinas/002172_S 1500-N.jpg'
                  }
                  alt={el.descripcion}
                  style={{ imageRendering: 'auto' }}
                  onError={(e) => {
                    // Fallback si la imagen no carga
                    e.currentTarget.src =
                      'https://h23api.for2home.com/CatalogData/ItemImages/Texturas/Cocinas_1_9_1/Cocinas/002172_S 1500-N.jpg'
                  }}
                />
                <div className='mt-3 flex w-32 flex-col items-start text-left text-xs'>
                  {(() => {
                    // Verificar si es Grifo o Fregadero
                    const isGrifo =
                      (childrenObject as any)?.typeOfSon === 'Grifo' ||
                      childrenObject?.description?.toLowerCase().includes('grifo')
                    const isFregadero =
                      (childrenObject as any)?.typeOfSon === 'Fregadero' ||
                      childrenObject?.description?.toLowerCase().includes('fregadero')

                    // Para Grifos y Fregaderos: solo mostrar descripcionLarga (sin descripcion)
                    if (isGrifo || isFregadero) {
                      return el.descripcionLarga ? <div>{el.descripcionLarga}</div> : null
                    }

                    // Para otros elementos: comportamiento normal
                    if ((el as any)._wereEqual) {
                      return <div>{el.descripcion}</div>
                    }

                    return (
                      <>
                        {el.descripcion && <div>{el.descripcion}</div>}
                        {el.descripcionLarga && <div className='mt-1'>{el.descripcionLarga}</div>}
                      </>
                    )
                  })()}
                </div>
              </div>
            )
          })}
      </div>
    )
  }

  return (
    <div className='flex h-full flex-col p-4'>
      <div className='mb-4 flex gap-4'>
        {isVitrinaModel() ? (
          <>
            <button
              className={clsx(
                'rounded px-4 py-2',
                modeEditor === 'Selected' ? 'bg-gray-800 text-white' : 'bg-gray-200',
              )}
              onClick={() => setModeEditor('Selected')}
            >
              {'Todas las Vitrinas'}
            </button>
            <button
              className={clsx(
                'rounded px-4 py-2',
                modeEditor === 'Single' ? 'bg-gray-800 text-white' : 'bg-gray-200',
              )}
              onClick={() => setModeEditor('Single')}
            >
              {'Solo este mueble'}
            </button>
          </>
        ) : (
          <>
            <button
              className={clsx(
                'rounded px-4 py-2',
                modeEditor === 'All' ? 'bg-gray-800 text-white' : 'bg-gray-200',
              )}
              onClick={() => setModeEditor('All')}
            >
              {'Toda la cocina'}
            </button>
            <button
              className={clsx(
                'rounded px-4 py-2',
                modeEditor === 'Single' || modeEditor === 'Selected'
                  ? 'bg-gray-800 text-white'
                  : 'bg-gray-200',
              )}
              onClick={() =>
                setModeEditor(isObjectSelected && isObjectSelected > 1 ? 'Selected' : 'Single')
              }
            >
              {isObjectSelected && isObjectSelected > 1 ? 'Seleccionados' : 'Solo este mueble'}
            </button>
            <button
              className={clsx(
                'rounded px-4 py-2',
                modeEditor === 'MBJ' ? 'bg-gray-800 text-white' : 'bg-gray-200',
              )}
              onClick={() => setModeEditor('MBJ')}
            >
              {'Muebles Bajos'}
            </button>
            <button
              className={clsx(
                'rounded px-4 py-2',
                modeEditor === 'MAL' ? 'bg-gray-800 text-white' : 'bg-gray-200',
              )}
              onClick={() => setModeEditor('MAL')}
            >
              {'Muebles Altos'}
            </button>
            <button
              className={clsx(
                'rounded px-4 py-2',
                modeEditor === 'COL' ? 'bg-gray-800 text-white' : 'bg-gray-200',
              )}
              onClick={() => setModeEditor('COL')}
            >
              {'Columnas'}
            </button>
          </>
        )}
      </div>
      {IamUp
        ? renderLinkedOptions()
        : !isModel && (
            <>
              <div className='pb-2 pl-2 text-sm font-semibold text-C/Color3'>{rightInfo.name}</div>
              <div
                ref={scrollableEditorRef}
                className='scrollable-editor flex max-h-[520px] flex-wrap gap-x-5 gap-y-9 overflow-x-hidden overflow-y-scroll p-2'
              >
                {rightInfo.textures.map((el, i, arr) => {
                  const isSelected = isSelectedTexture(el)
                  const isOnlyOne = arr.length === 1
                  const shouldHighlight = isSelected || isOnlyOne

                  return (
                    <div
                      key={`$${i}+${el.nombre}-${el.url}-${el.descripcion}`}
                      className='flex max-h-44 flex-col'
                    >
                      <img
                        src={el.urlMiniatura ? encodeURI(el.urlMiniatura) : encodeURI(el.url)}
                        onClick={() => handleClick(el)}
                        className={clsx(
                          'h-32 w-32 cursor-pointer object-contain',
                          shouldHighlight &&
                            'selected elElegido outline outline-4 outline-C/Color6',
                        )}
                        style={{ imageRendering: 'auto' }}
                      />
                      {/* <div className='mt-2 flex w-32 text-xs'>
                        {selectedTexture?.zone === 'Puerta' ||
                        !el.descripcion ||
                        el.nombre === el.descripcion
                          ? el.nombre
                          : `${el.nombre} ${el.descripcion}`}
                      </div> */}
                      <div className='mt-2 flex w-32 flex-col text-xs'>
                        {(() => {
                          const textBase =
                            selectedTexture?.zone === 'Puerta' ||
                            !el?.descripcion ||
                            el?.nombre === el?.descripcion
                              ? el?.nombre
                              : `${el?.nombre ?? ''} ${el?.descripcion ? normalizeDescripcionLarga(el.descripcion) : ''}`

                          const text = textBase ?? ''
                          const words = String(text).split(' ')
                          const firstWord = words[0]
                          const restOfText = words.slice(1).join(' ')

                          return (
                            <>
                              <span>{firstWord}</span>
                              {restOfText && <span>{restOfText}</span>}
                            </>
                          )
                        })()}
                      </div>
                    </div>
                  )
                })}
              </div>
            </>
          )}
      <EditorButtons closeFn={closeFn} />
    </div>
  )
}
